import { humanMs } from './areas';

// How a vehicle's tracking reads at a glance, kept apart from any screen so it can be reasoned
// about - and tested - without dragging a map renderer in behind it.

// What a tenant is told about a platform device it is not currently entitled to see.
//
// One tracker can serve several plants. A plant may watch it while it runs that plant's trip or
// stands on that plant's site, and not otherwise, so there is often no position to show at all.
// Saying "never reported" there would be untrue of a unit reporting perfectly well on somebody
// else's load, and would send a yard looking for a fault that does not exist.
export const NOT_ON_TRIP = 'NOT_ON_TRIP';

export const reportingState = (position, intervalMs) => {
  if (position?.trackingStatus === NOT_ON_TRIP) return { label: 'Not on your trip', color: 'default', quiet: true, withheld: true };
  if (!position?.fixTime) return { label: 'No fix yet', color: 'default', quiet: true };
  const age = Date.now() - Date.parse(position.fixTime);
  if (!Number.isFinite(age)) return { label: 'No fix yet', color: 'default', quiet: true };
  if (!intervalMs) return { label: `Last fix ${humanMs(age)} ago`, color: 'default', quiet: false };
  return age <= intervalMs
    ? { label: 'Reporting', color: 'success', quiet: false }
    : { label: `Quiet ${humanMs(age)}`, color: 'warning', quiet: true };
};
